/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Tag, Card, Spin } from 'antd';

import { useTranslation } from 'react-i18next';
import QRCode from 'qrcode.react';
import moment from 'moment';
import {
  ReservationWrapper,
  ReservationFormWrapper,
} from './Reservation.styled';
import { getProductByIdAction } from '../../data/modules/products/products.actions';
import {
  FlexDivCenter,
  Text,
  TextSpan,
} from '../../components/Typography/Typography';
import { formatCurrency } from '../../utils';
import 'moment/locale/he';
import UseMedia from '../../customHooks/UseMedia';
import GiftForm from './GiftForm';
import RentForm from './RentForm';
import ServiceForm from './ServiceForm';
import EventForm from './EventForm';
import LockerForm from './LockerForm';

const startDatetime = moment().utc().add(2, 'days');
const endDatetime = startDatetime.clone().add(2, 'hours');
const duration = moment.duration(endDatetime.diff(startDatetime)).asHours();
const event = {
  description:
    'Description of event. Going to have a lot of fun doing things that we scheduled ahead of time.',
  duration,
  endDatetime: endDatetime.format('YYYYMMDDTHHmmssZ'),
  location: 'NYC',
  startDatetime: startDatetime.format('YYYYMMDDTHHmmssZ'),
  title: 'Super Fun Event',
};

export default () => {
  const { productId } = useParams();
  const dispatch = useDispatch();
  const [activeProduct, setActiveProduct] = useState({});
  const [loading, setLoading] = useState(true);
  const { isMobile } = UseMedia();
  const { t } = useTranslation();
  const [isFinishedQR, setIsFinishedQR] = useState(false);
  const { activeUser } = useSelector((state) => state.auth);

  const formMapperByProductType = {
    gift: (
      <GiftForm setIsFinished={setIsFinishedQR} activeProduct={activeProduct} />
    ),
    rent: (
      <RentForm setIsFinished={setIsFinishedQR} activeProduct={activeProduct} />
    ),
    sg_services: (
      <ServiceForm
        setIsFinished={setIsFinishedQR}
        activeProduct={activeProduct}
      />
    ),
    event: (
      <EventForm
        setIsFinished={setIsFinishedQR}
        activeProduct={activeProduct}
      />
    ),
    locker: (
      <LockerForm
        setIsFinished={setIsFinishedQR}
        activeProduct={activeProduct}
        setActiveProduct={setActiveProduct}
      />
    ),
  };

  useEffect(() => {
    setLoading(true);
    dispatch(getProductByIdAction(productId)).then((product) => {
      const append = product.type === "locker" ? { price: null, description: null } : {};
      setActiveProduct({ ...product, ...append });
      setLoading(false);
    });
  }, [productId]);

  function renderProductType(val) {
    const tagColorMapper = {
      gift: 'green',
      rent: 'orange',
      sell: 'red',
    };
    return (
      <Text size="large">
        <Tag style={{ fontSize: 18 }} color={tagColorMapper[val]}>
          {' '}
          {`${t(val)}`}
        </Tag>{' '}
        { }
      </Text>
    );
  }

  function renderPrice(val) {
    return (
      <Text size="large" style={{ fontSize: 18 }}>
        {val ? formatCurrency(val) : ''}
      </Text>
    );
  }

  function renderFinishScreen() {
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Card style={{ background: 'white' }}>
          <FlexDivCenter>
            <FlexDivCenter
              style={{
                padding: '0 20px',
                fontSize: 20,
                textAlign: 'center',
                fontWeight: 900,
                textDecoration: 'underline',
              }}
            >
              {t('screenshot_and_keep_when_taking')}
            </FlexDivCenter>
            <QRCode
              value={isFinishedQR}
              size={400}
              bgColor="#ffffff"
              fgColor="#000000"
              level="L"
              includeMargin
            // renderAs="svg"
            />
          </FlexDivCenter>
          <FlexDivCenter>
            <Text style={{ padding: '0 20px' }} bold size="xlarge">
              ברגעים אלו נשלח אליכם מייל עם פרטי ההזמנה, במידה ואינכם רואים את
              המייל - נסו לבדוק בתיבת הספאם שלכם.
            </Text>
          </FlexDivCenter>
        </Card>
      </div>
    );
  }

  return (
    <ReservationWrapper className="animate__animated animate__fadeIn">
      <FlexDivCenter>
        {loading ? (
          <FlexDivCenter
            style={{ height: '80vh', alignItems: 'center', margin: '30px 0' }}
          >
            <Spin size="large" />
          </FlexDivCenter>
        ) : (
          <div>
            {isFinishedQR ? (
              <div>{renderFinishScreen()}</div>
            ) : (
              <>
                <ReservationFormWrapper
                  title={
                    <>
                      <div
                        style={{
                          marginTop: 0,
                          width: isMobile ? undefined : 400,
                        }}
                      >
                        <FlexDivCenter>
                          <Text bold size="xlarge">
                            {activeProduct.type === "locker" ? t("locker_rent") : activeProduct.name}
                          </Text>
                        </FlexDivCenter>
                        {activeProduct.type === 'event' && (
                          <Text bold>{activeProduct.dateAndTime}</Text>
                        )}
                      </div>
                      {activeProduct.imageUrl && (
                        <FlexDivCenter>
                          <img
                            src={activeProduct.imageUrl}
                            style={{
                              margin: 5,
                              position: 'relative',
                              width: isMobile ? '80%' : 250,
                            }}
                            alt="image"
                          />
                        </FlexDivCenter>
                      )}
                      <FlexDivCenter>
                        <div style={{ textAlign: 'right', maxWidth: 350 }}>
                          {activeProduct.description && activeProduct.description !== '0' && (
                            <TextSpan
                              style={{
                                direction: 'rtl',
                                whiteSpace: 'pre-line',
                              }}
                            >
                              {activeProduct.type !== 'event' && (
                                <Text
                                  style={{ textDecoration: 'underline' }}
                                  bold
                                >
                                  {t('product_description')}:
                                </Text>
                              )}
                              {activeProduct.description}
                            </TextSpan>
                          )}
                        </div>
                      </FlexDivCenter>
                      {activeProduct.price ? (
                        <FlexDivCenter margin="20px 0">
                          <Text
                            bold
                            size="xlarge"
                            style={{ direction: 'rtl', whiteSpace: 'pre-line' }}
                          >
                            {`${t('price')}: ${formatCurrency(
                              activeProduct.price
                            )}`}
                          </Text>
                        </FlexDivCenter>
                      ) : null}
                      {(activeProduct.discountPrice || activeProduct.discountPrice === 0) ? (
                        <FlexDivCenter margin="20px 0">
                          <Text
                            bold
                            size="xlarge"
                            style={{ direction: 'rtl', whiteSpace: 'pre-line' }}
                          >
                            {`${t('discount_price')}: ${activeProduct.discountPrice ? formatCurrency(
                              activeProduct.discountPrice
                            ) : t('free')}`}
                          </Text>
                        </FlexDivCenter>
                      ) : null}
                    </>
                  }
                  style={{ margin: '10px 0', background: '#FFF' }}
                >
                  {formMapperByProductType[activeProduct.type]}
                </ReservationFormWrapper>
              </>
            )}
          </div>
        )}
      </FlexDivCenter>
    </ReservationWrapper>
  );
};
